"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cpReportUpdatePanel = exports.cpReportUpdateHeaderImage = exports.cpReportUpdateGreeting = exports.cpReportUpdateFundSequencePanel = exports.cpReportSuccess = exports.cpReportReset = exports.cpReportPanelList = exports.cpReportGetReportDefaultByOrgId = exports.cpReportGetReportDefault = exports.cpReportGetHeaderImageList = exports.cpReportGetHeaderImage = exports.cpReportGetGreeting = exports.cpReportGetBuilderReportById = exports.cpReportGetAssetFolderList = exports.cpReportError = exports.cpReportDeletePanel = exports.cpReportAddUpdateReportDefault = exports.cpReportAddReportDefault = void 0;
var _cpReport = require("./cpReport.constant");
// @flow

// common success
var cpReportSuccess = function cpReportSuccess(actionType, data) {
  return {
    type: _cpReport.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.cpReportSuccess = cpReportSuccess;
var cpReportError = function cpReportError(actionType, error) {
  return {
    type: _cpReport.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpReportError = cpReportError;
var cpReportGetReportDefault = function cpReportGetReportDefault(data) {
  return {
    type: _cpReport.actionTypes.GET_REPORT_DEFAULT,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.cpReportGetReportDefault = cpReportGetReportDefault;
var cpReportAddReportDefault = function cpReportAddReportDefault(data) {
  return {
    type: _cpReport.actionTypes.ADD_REPORT_DEFAULT,
    payload: data
  };
};

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.cpReportAddReportDefault = cpReportAddReportDefault;
var cpReportAddUpdateReportDefault = function cpReportAddUpdateReportDefault(data) {
  return {
    type: _cpReport.actionTypes.ADD_UPDATE_REPORT_DEFAULT_CP,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpReportAddUpdateReportDefault = cpReportAddUpdateReportDefault;
var cpReportGetReportDefaultByOrgId = function cpReportGetReportDefaultByOrgId(data) {
  return {
    type: _cpReport.actionTypes.GET_REPORT_BY_ID,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpReportGetReportDefaultByOrgId = cpReportGetReportDefaultByOrgId;
var cpReportUpdateGreeting = function cpReportUpdateGreeting(data) {
  return {
    type: _cpReport.actionTypes.UPDATE_GREETING,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpReportUpdateGreeting = cpReportUpdateGreeting;
var cpReportUpdateHeaderImage = function cpReportUpdateHeaderImage(data) {
  return {
    type: _cpReport.actionTypes.UPDATE_HEADER_IMAGE,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpReportUpdateHeaderImage = cpReportUpdateHeaderImage;
var cpReportUpdateFundSequencePanel = function cpReportUpdateFundSequencePanel(data) {
  return {
    type: _cpReport.actionTypes.UPDATE_PANEL_SEQUENCE,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpReportUpdateFundSequencePanel = cpReportUpdateFundSequencePanel;
var cpReportGetHeaderImage = function cpReportGetHeaderImage(data) {
  return {
    type: _cpReport.actionTypes.GET_HEADER_IMAGE,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpReportGetHeaderImage = cpReportGetHeaderImage;
var cpReportGetBuilderReportById = function cpReportGetBuilderReportById(data) {
  return {
    type: _cpReport.actionTypes.GET_BUILDER_REPORT_BY_ID,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpReportGetBuilderReportById = cpReportGetBuilderReportById;
var cpReportGetAssetFolderList = function cpReportGetAssetFolderList(data) {
  return {
    type: _cpReport.actionTypes.GET_ASSET_FOLDER_LIST,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpReportGetAssetFolderList = cpReportGetAssetFolderList;
var cpReportPanelList = function cpReportPanelList(data) {
  return {
    type: _cpReport.actionTypes.PANEL_LIST,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpReportPanelList = cpReportPanelList;
var cpReportGetGreeting = function cpReportGetGreeting(data) {
  return {
    type: _cpReport.actionTypes.GET_GREETING,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.cpReportGetGreeting = cpReportGetGreeting;
var cpReportDeletePanel = function cpReportDeletePanel(data) {
  return {
    type: _cpReport.actionTypes.DELETE_PANEL,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.cpReportDeletePanel = cpReportDeletePanel;
var cpReportUpdatePanel = function cpReportUpdatePanel(data) {
  return {
    type: _cpReport.actionTypes.UPDATE_PANEL,
    payload: data
  };
};

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
exports.cpReportUpdatePanel = cpReportUpdatePanel;
var cpReportGetHeaderImageList = function cpReportGetHeaderImageList(data) {
  return {
    type: _cpReport.actionTypes.GET_HEADER_IMAGE_LIST,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.cpReportGetHeaderImageList = cpReportGetHeaderImageList;
var cpReportReset = function cpReportReset() {
  return {
    type: _cpReport.actionTypes.RESET
  };
};
exports.cpReportReset = cpReportReset;